import { createReducer } from '@reduxjs/toolkit';
import { getSkillTags, addSkillTag, deleteSkillTag, tagLectureComponent, removeTagLectureComponent } from 'redux/actions/skill-tags';
import { normalize } from 'normalizr';
import { skilltagsSchema } from 'redux/schemas/api/skill-tag';
import { SkillTagState } from 'redux/schemas/models/skill-tag';
import { ComponentType } from 'redux/schemas/models/lecture-component';
import { initialRootState } from '.';

export const initialSkillTagState: SkillTagState = {
  lastInsertedTagId: -1,
  isLoading: false,
  hasBeenLoaded: false,
};

export default createReducer(initialRootState, builder => {
  builder
    .addCase(getSkillTags.pending, (state, action) => {
      state.app.skillTag.isLoading = true;
    })
    .addCase(getSkillTags.fulfilled, (state, action) => {
      const data = normalize(action.payload, skilltagsSchema);
      Object.assign(state.models.skillTags, data.entities.skilltags);
      state.app.skillTag.hasBeenLoaded = true;
      state.app.skillTag.isLoading = false;
    })
    .addCase(addSkillTag.fulfilled, (state, action) => {
      state.models.skillTags[action.payload.id] = action.payload;
      state.app.skillTag.lastInsertedTagId = action.payload.id;
    })
    .addCase(deleteSkillTag.fulfilled, (state, action) => {
      delete state.models.skillTags[action.meta.arg.tag.id];
    })
    .addCase(tagLectureComponent.fulfilled, (state, action) => {
      const component = state.models.lectureComponents[action.meta.arg.lectureComponentId];
      component.skillTags = component.skillTags || [];
      state.models.lectureComponents[action.meta.arg.lectureComponentId].skillTags = [...component.skillTags, action.payload];
      state.app.skillTag.hasBeenLoaded = false;
    })
    .addCase(removeTagLectureComponent.fulfilled, (state, action) => {
      const tags = state.models.lectureComponents[action.meta.arg.lectureComponentId].skillTags || [];
      state.models.lectureComponents[action.meta.arg.lectureComponentId].skillTags = tags.filter(item => item.id !== action.meta.arg.skillTagId);
      state.app.skillTag.hasBeenLoaded = false;
    });
});
